import React from 'react'
import { Accordion, AccordionItem } from './Accordion'

export default function CollaboratorProjects(props) {
  const {
    collaboratorProjects, handleItemClick, activeProject, searchProjectKeyword
  } = props
  const keyword = searchProjectKeyword.trim().toLowerCase()
  let projects = collaboratorProjects
  if (keyword) {
    projects = collaboratorProjects.filter(
        project => project.title.toLowerCase().includes(keyword))
  }
  if (projects.length < 1) return null

  return (
    <Accordion teamName="Shared Projects"
               noOfProjects={projects.length}>
      {projects.map(project =>
        <AccordionItem
          key={project.id}
          title={project.title}
          active={activeProject.id === project.id}
          noOfVideos={project.videosCount}
          onClick={handleItemClick(project)} />
      )}
    </Accordion>
  )
}



// WEBPACK FOOTER //
// ./src/Components/SideBarLeft/CollaboratorProjects.js